export const LOAD_ALL_OTHERLABS = 'LOAD_ALL_OTHERLABS'
export const CREATE_OTHERLAB = 'CREATE_OTHERLAB'
export const DELETE_OTHERLAB = 'DELETE_OTHERLAB'
export const UPDATE_OTHERLAB = 'UPDATE_OTHERLAB'
// export const UPLOAD_REQUIRED_FILES = 'UPLOAD_REQUIRED_FILES'